"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getMiniprogramParams = exports.miniprogramJumpQuery = exports.miniprogramparamsArrList = exports.MiniprogramparamsArrItems = void 0;
var querystring_1 = __importDefault(require("querystring"));
var cookie_1 = require("./cookie");
var MiniprogramparamsArrItems;
(function (MiniprogramparamsArrItems) {
    MiniprogramparamsArrItems["miniprogram"] = "miniprogram";
    MiniprogramparamsArrItems["openId"] = "openId";
    MiniprogramparamsArrItems["miniWexinAppId"] = "miniWexinAppId";
    MiniprogramparamsArrItems["loginNavigator"] = "loginNavigator";
})(MiniprogramparamsArrItems || (exports.MiniprogramparamsArrItems = MiniprogramparamsArrItems = {}));
// 小程序相关参数
exports.miniprogramparamsArrList = [
    MiniprogramparamsArrItems.miniprogram,
    MiniprogramparamsArrItems.openId,
    MiniprogramparamsArrItems.miniWexinAppId,
    MiniprogramparamsArrItems.loginNavigator,
];
// 小程序下的各种跳转要加上这个方法（参数加工），才能正确跳转，也可以save直接种下参数以为后续需求来使用
function miniprogramJumpQuery(url, save, domain, forceSave, forceEqual, useCookie) {
    if (save === void 0) { save = false; }
    if (forceSave === void 0) { forceSave = false; }
    if (forceEqual === void 0) { forceEqual = false; }
    if (useCookie === void 0) { useCookie = false; }
    var _url = url;
    try {
        var func_1 = function (k, v) {
            if (_url && k && v) {
                if (!(_url === null || _url === void 0 ? void 0 : _url.includes("?"))) {
                    _url = "".concat(_url, "?").concat(k, "=").concat(v);
                }
                else {
                    _url = "".concat(_url, "&").concat(k, "=").concat(v);
                }
            }
        };
        var search = window.location.search;
        var query_1 = querystring_1.default.parse(search.startsWith("?") ? search.slice(1) : search);
        // console.log("query", query);
        if (!domain) {
            var _hostStr = window.location.hostname.split(".");
            var _hostStrLen = _hostStr.length;
            var _hostStr2 = _hostStr.slice(_hostStrLen - 2, _hostStrLen);
            domain = ".".concat(_hostStr2.join("."));
        }
        exports.miniprogramparamsArrList.forEach(function (k) {
            var v = query_1[k];
            if (v) {
                if (save) {
                    if (forceSave) {
                        sessionStorage.setItem(k, v);
                        useCookie && (0, cookie_1.setCookie)(k, v, { domain: domain });
                    }
                    else {
                        var val1 = (0, cookie_1.getCookie)(k);
                        var val2 = sessionStorage.getItem(k);
                        if (!val1 && !val2) {
                            sessionStorage.setItem(k, v);
                            useCookie && (0, cookie_1.setCookie)(k, v, { domain: domain });
                        }
                        else if (!val1 && val2) {
                            useCookie && (0, cookie_1.setCookie)(k, v, { domain: domain });
                            if (val2 !== v) {
                                console.warn("session 和 cookie 不一致", { k: k, v: v, val2: val2 });
                                if (forceEqual) {
                                    sessionStorage.setItem(k, v);
                                }
                            }
                        }
                        else if (val1 && !val2) {
                            sessionStorage.setItem(k, v);
                            if (val1 !== v) {
                                console.warn("session 和 cookie 不一致", { k: k, v: v, val1: val1 });
                                if (forceEqual) {
                                    useCookie && (0, cookie_1.setCookie)(k, v, { domain: domain });
                                }
                            }
                        }
                    }
                }
                if (_url) {
                    func_1(k, v);
                }
            }
        });
    }
    catch (e) { }
    return _url;
}
exports.miniprogramJumpQuery = miniprogramJumpQuery;
// 使用的时候，最好通过该方法获取参数，来保证正确获取到小程序的参数
function getMiniprogramParams(miniprogramHasDefault, // 只有在提单的时候给默认值需要，否则不需要
useCookie, getFromSearch // 是否从地址栏获取参数
) {
    if (miniprogramHasDefault === void 0) { miniprogramHasDefault = false; }
    if (useCookie === void 0) { useCookie = false; }
    if (getFromSearch === void 0) { getFromSearch = true; }
    var mp = new Map();
    var query;
    if (getFromSearch) {
        var search = window.location.search;
        query =
            querystring_1.default.parse(search.startsWith("?") ? search.slice(1) : search) ||
                {};
    }
    exports.miniprogramparamsArrList.forEach(function (item) {
        var val = (query === null || query === void 0 ? void 0 : query[item]) || sessionStorage.getItem(item);
        if (useCookie && !val) {
            val = (0, cookie_1.getCookie)(item);
        }
        if (item === "miniprogram" && !val && miniprogramHasDefault) {
            val = "jdjk"; // nethp | famdoc
        }
        mp.set(item, val);
    });
    return mp;
}
exports.getMiniprogramParams = getMiniprogramParams;
